import { Component, Input, OnChanges, OnInit, OnDestroy, ViewChild, ElementRef} from '@angular/core';
import { Router } from '@angular/router';


@Component({
  selector: 'app-crm-home',
  templateUrl: './crm-home.component.html',
  styleUrls: ['./crm-home.component.scss']
})
export class CrmHomeComponent implements OnInit, OnChanges, OnDestroy {
  @Input() email?: string;
  @Input() telephone?: string;
  @Input() address?: string;
  @ViewChild('sliderRef') sliderRef!: ElementRef;

  displayList: any[] = [];
  currentIndex = 0;
  private interval: any;
  isPaused = false;
  private isTransitioning = false;

  displayTerms = true;
  crm_images = [["healthfoods", "HEALTH FOODS", false], ["therealestate", "REAL ESTATE", false], ["thecardealership", "CAR DEALERSHIP", false],
  ["buildingcontract", "BUILDING CONTRACTORS", false], ["healthinsurance", "LIFE & HEALTH INSURANCE ", false], ["travel", "TRAVEL", false],
  ["kitchenappliance", "KITCHEN APPLIANCES", false], ["jewelry", "Jewellery ", false], ["fashionstyle", "Fashion & lifestyle ", false],
  ["homedecor", "Home decor ", false], ["restaurant", "Restaurant", false], ["sports", "Sports", false], ["thehomeappliance", "Home appliances", false],
  ["grocery1", "Grocery", false], ["thepetgrooming", "Pet Groom", false], ["musicinstrument", "Musical instrument", false], ["thefitnesshub", "Fitness", false],
  ["applianceservice", "Appliance service", false], ["cardetailing", "Car detailing", false], ["theautotraders", "Auto traders", false],
  ["landscaper", "Landscappers", false], ["thehomegardens", "Home and garden supplies", false], ["hardware", "Hardware", false],
  ["beautyspa", "Beauty & Spa", false], ["saloon", "Saloon", false], ["mobile", "Mobile Phones", false], ["furniture", "Furniture", false],
  ["kidstoys", "Kid's Toy", false], ["petfood", "Pet Foods", false], ["supplementstore", "Health Supplements", false]];


  showcases = [
    { image: 'showcase-1.jpg', alt: 'Smart Site Example 1', title: 'Retail Store Smart Site', delay: 0 },
    { image: 'showcase-2.jpg', alt: 'Smart Site Example 2', title: 'Restaurant QR Experience', delay: 100 },
    { image: 'showcase-3.jpg', alt: 'Smart Site Example 3', title: 'Service Booking Smart Site', delay: 200 },
    { image: 'showcase-4.jpg', alt: 'Smart Site Example 4', title: 'Product Promotion QR Site', delay: 300 }
  ];

  features = [
    { text: 'End-to-End Data Encryption', delay: 0 },
    { text: 'Real-Time Business Insights', delay: 80 },
    { text: 'AI-Powered Campaign Optimization', delay: 140 },
    { text: 'Dedicated Onboarding & Support', delay: 200 },
    { text: 'Scalable from Single Store to Enterprise', delay: 260 }
  ];

  steps = [
    {
      image: 'how-it-works-1.png',
      alt: 'Step 1 - Create Smart Site',
      title: 'Create Your Smart Site',
      text: 'Sign up and build your first Smart Site in minutes with our drag-and-drop interface.'
    },
    {
      image: 'how-it-works-2.png',
      alt: 'Step 2 - Launch Smart Promo',
      title: 'Launch Smart Promo',
      text: 'Engage your customers instantly through QR-powered promotions and offers.'
    },
    {
      image: 'how-it-works-3.png',
      alt: 'Step 3 - Connect Platforms',
      title: 'Connect Your Systems',
      text: 'Integrate with your POS, CRM, and social platforms to unify your customer data.'
    },
    {
      image: 'how-it-works-4.png',
      alt: 'Step 4 - Track and Optimize',
      title: 'Track & Optimize',
      text: 'Monitor real-time analytics and insights to refine your campaigns and maximize ROI.'
    }
  ];

  constructor(
    private router: Router
  ) { }
  ngOnDestroy(): void {
    if (this.interval) clearInterval(this.interval);
  }

  ngOnInit(): void {

    this.displayList = [...this.crm_images, ...this.crm_images.slice(0, 6)];
    this.startAutoPlay();

    // this.registerData.email.subscribe(v => v && (this.email = v));
    // this.registerData.telephone.subscribe(v => v && (this.telephone = v));
    // this.registerData.address.subscribe(v => v && (this.address = v));

    // this.registerData.country.subscribe(v => {
    //   if (v) {
    //     const c = v.toLowerCase();
    //     this.countryName = ['india', 'canada'].includes(c) ? c : 'default';
    //   }
    // });
  }

  ngOnChanges() {
    if (this.email == null) {
      this.email = "hello@scanfluence.com";
    }

    if (this.telephone == null) {
      this.telephone = "+1 (437) 826 SCAN";
    }

    if (this.address == null) {
      this.address = "3600 Steeles Avenue East, Markham, ON, L3R 9Z7";
    }
  }

  showDisplay() {
    this.displayTerms = !this.displayTerms;
  }

  openTerms(event?: Event) {
    if (event) { event.preventDefault(); }
    this.router.navigate(['/terms']);
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });

  }
  openPrivacy(event?: Event) {
    if (event) { event.preventDefault(); }
    this.router.navigate(['/privacy-policy']);
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });

  }
  openCookie(event?: Event) {
    if (event) { event.preventDefault(); }
    this.router.navigate(['/cookie']);
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }

  //caraosel functions
  startAutoPlay() {
    this.interval = setInterval(() => {
      if (!this.isPaused) this.moveNext();
    }, 1500);
  }

  moveNext() {
    if (this.isTransitioning) return;
    this.currentIndex++;
    this.updateTransform(true);
  }

  movePrev() {
    if (this.isTransitioning) return;

    if (this.currentIndex <= 0) {
      // If at the very start, jump to the end of the real list instantly first
      this.jumpTo(this.crm_images.length);
      setTimeout(() => {
        this.currentIndex--;
        this.updateTransform(true);
      }, 10);
    } else {
      this.currentIndex--;
      this.updateTransform(true);
    }
  }

  private updateTransform(withTransition: boolean) {
    this.isTransitioning = true;
    const el = this.sliderRef.nativeElement;
    const cardWidth = el.children[0].offsetWidth + 20; // width + gap

    el.style.transition = withTransition ? 'transform 0.6s cubic-bezier(0.25, 1, 0.5, 1)' : 'none';
    el.style.transform = `translateX(-${this.currentIndex * cardWidth}px)`;

    // Check if we've reached the cloned items
    if (this.currentIndex >= this.crm_images.length) {
      setTimeout(() => {
        this.jumpTo(0);
      }, 600); // Wait for transition to finish
    } else {
      setTimeout(() => this.isTransitioning = false, 600);
    }
  }

  private jumpTo(index: number) {
    this.currentIndex = index;
    const el = this.sliderRef.nativeElement;
    const cardWidth = el.children[0].offsetWidth + 20;
    el.style.transition = 'none';
    el.style.transform = `translateX(-${this.currentIndex * cardWidth}px)`;
    this.isTransitioning = false;
  }

  pause() { this.isPaused = true; }
  resume() { this.isPaused = false; }
  getQrUrl(item: any[]): string {
    return `https://stage.onoffer.live/#/${item}`;
  }
  getIconPath(item: any[]): string {
    return `assets/icons/icon/${item}.png`;
  }

  toggle(item: any[]) {
    item[2] = !item[2];
  }

}
